import type { ShipmentEventType } from "../shipments/types";

export const SMART_TRACKING_RULE_IDS = [
  "unit_moving",
  "unit_stopped",
  "unit_at_destination",
  "unit_alert",
  "unit_no_signal",
] as const;

export type SmartTrackingRuleId = (typeof SMART_TRACKING_RULE_IDS)[number];

export type SmartTrackingRules = Record<SmartTrackingRuleId, boolean>;

export interface SmartTrackingRuleMeta {
  icon: string;
  eventType: ShipmentEventType | null;
  automatic: boolean;
}

export const SMART_TRACKING_RULES = {
  unit_moving: {
    icon: "ri-speed-up-line",
    eventType: "transit",
    automatic: true,
  },
  unit_stopped: {
    icon: "ri-parking-box-line",
    eventType: "intermediate",
    automatic: true,
  },
  unit_at_destination: {
    icon: "ri-map-pin-2-line",
    eventType: "delivered",
    automatic: true,
  },
  unit_alert: {
    icon: "ri-alert-line",
    eventType: "incident",
    automatic: true,
  },
  unit_no_signal: {
    icon: "ri-cloud-off-line",
    eventType: null,
    automatic: false,
  },
} as const satisfies Record<SmartTrackingRuleId, SmartTrackingRuleMeta>;

export const DEFAULT_SMART_TRACKING_RULES = {
  unit_moving: true,
  unit_stopped: true,
  unit_at_destination: true,
  unit_alert: true,
  unit_no_signal: false,
} as const satisfies SmartTrackingRules;

export interface SmartTrackingConfig {
  company_id: string | null;
  enabled: boolean;
  rules: SmartTrackingRules;
  updated_by: string | null;
}

export interface SmartTrackingConfigInput {
  enabled?: boolean;
  rules?: Partial<SmartTrackingRules>;
}

export const DEFAULT_SMART_TRACKING_CONFIG: SmartTrackingConfig = {
  company_id: null,
  enabled: false,
  rules: DEFAULT_SMART_TRACKING_RULES,
  updated_by: null,
};

export const sameSmartTrackingConfig = (
  a: SmartTrackingConfig,
  b: SmartTrackingConfig,
): boolean =>
  a.enabled === b.enabled &&
  SMART_TRACKING_RULE_IDS.every((id) => a.rules[id] === b.rules[id]);
